/**
 * Renderer → main: set the dock / taskbar unread badge. Payload is the total
 * count; main renders presence only (a dot while positive, cleared at zero).
 */
export const APP_BADGE_SET_EVENT = 'app-badge:set'
